require('./brokerMyInvestmentsWrappedProductsTable.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @commons
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { OKIconButton } = require('commonsComponents/OKIconButton');
const { PopoverMenu } = require('commonsComponents/popoverMenu');
const { OKLink } = require('commonsComponents/OKLink');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { getPublicSiteUrl } = require('core/apiURLBuilder');
const { formatCurrency, formatWithoutRound } = require('utilities/currencyHelper');
const classNames = require('classnames');
const { taggingEventHandled } = require('utilities/taggingEventHandled');


// @actions
const BrokerMyInvestmentWidgetActions = require('actions/brokerMyInvestmentWidget');

// @constants
const {
    ACCOUNT_INTERVENTION_OWNER,
    BROKER_CORPORATE_OPERATIONS_URL,
    BROKER_TRANSFER_CALLME_BACK_EXTERNAL_VALUES_URL,
    BROKER_TRANSFER_EXTERNAL_VALUES,
    BROKER_TRANSFER_PENSION_PLAN_URL,
    HYPHEN,
    LABEL_ALTERNATIVE_FUNDS,
    MYPROFILE_BROKER_CRYPTO_URL,
    MYPROFILE_BROKER_ETFS_URL,
    MYPROFILE_BROKER_FUNDS_URL,
    MYPROFILE_BROKER_INTERNAL_TRANSFER_FUND,
    MYPROFILE_BROKER_ORDERSANDMOVEMENTS_URL,
    MYPROFILE_BROKER_PENSION_PLAN_PERIODICAL_CONTRIBUTION_URL,
    MYPROFILE_BROKER_PLANS_URL,
    MYPROFILE_BROKER_STOCKS_URL,
    MYPROFILE_BROKER_WARRANTS_URL,
    TYPE_ALTERNATIVE_FUNDS_PG,
    TYPE_CRYPTO_PG,
    TYPE_ETFS,
    TYPE_FUNDS,
    TYPE_OTHERS,
    TYPE_PLANS,
    TYPE_STOCKS,
    TYPE_WARRANTS,
} = require('constants/index');
const {
    BRING_MY_FUNDS,
    BRING_MY_FUNDS_INFO_VIEW,
    BRING_VALUES_TO_OK,
    BROKER_CAMBIOS_COMERCIALIZADORA,
    FUNDS_TRANSFER, OPENTRADER,
    FUNDS_PERIODIC_CONTRIBUTION
} = require('constants/flagBasedFeatures');

// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

class BrokerMyInvestmentsWrappedProductsTable extends React.Component {
    constructor(props) {
        super(props);

        this.buildProductTitle = this.buildProductTitle.bind(this);
        this.buildHeader = this.buildHeader.bind(this);
        this.getPopoverMenuItems = this.getPopoverMenuItems.bind(this);
        this.handleContributionsSimulatorClick = this.handleContributionsSimulatorClick.bind(this);
        this.handleOpenTraderClick = this.handleOpenTraderClick.bind(this);
        this.handleOrdersAndMovementsClick = this.handleOrdersAndMovementsClick.bind(this);
        this.handleAcordionClick = this.handleAcordionClick.bind(this);
        this.handleAccordionToggle = this.handleAccordionToggle.bind(this);
    }

    checkMenuVisible = (items) => {
        return items.some(item => item.visible);
    }

    getPopoverMenuItems() {
        const { type, itemsNumber, flagBasedFeatures } = this.props;
        const productLabel = formatText(`externalTransferValues-externalTransferValues_${type}`);
        const transferValuesTitle = formatText('breadcrumb-breadcrumb_externalTransferValues', [productLabel]);
        const transferCallbackExternalValuesUrl = flagBasedFeatures.get(BRING_VALUES_TO_OK);
        const transferExternalSecuritiesEnabled = flagBasedFeatures.get(BROKER_CAMBIOS_COMERCIALIZADORA);
        const ffContributions = flagBasedFeatures.get(FUNDS_PERIODIC_CONTRIBUTION);
        let items = [
            {
                visible: transferExternalSecuritiesEnabled && (type === TYPE_STOCKS || type === TYPE_ETFS || type === TYPE_WARRANTS),
                link: `${BROKER_TRANSFER_EXTERNAL_VALUES}/${type}`,
                text: transferValuesTitle
            },
            {
                visible: transferCallbackExternalValuesUrl && (type === TYPE_STOCKS || type === TYPE_ETFS || type === TYPE_WARRANTS),
                link: BROKER_TRANSFER_CALLME_BACK_EXTERNAL_VALUES_URL,
                handleClick: () => this.handleMenuTagging(type, `getMy${type}`),
                text: formatText('brokerMyInvestmentsMoreOptions-traspassValuesToOpenbank')
            },
            {
                visible: type === TYPE_STOCKS || type === TYPE_ETFS || type === TYPE_WARRANTS,
                link: `/myprofile/broker/transferValues`,
                handleClick: () => this.handleMenuTagging(type, `TransferBetweenContracts`),
                text: formatText('brokerMyInvestmentsMoreOptions-trasspassValues')
            },
            {
                visible: flagBasedFeatures.get(BRING_MY_FUNDS) && type === TYPE_FUNDS,
                link: flagBasedFeatures.get(BRING_MY_FUNDS_INFO_VIEW) ? '/myprofile/broker/externalTransferFundInfoView' : `/myprofile/broker/externalTransferFund`,
                handleClick: () => this.handleMenuTagging(type, `getMyFunds`),
                text: formatText('brokerMyInvestmentsMoreOptions-traspassFundsToOpenbank')
            },
            {
                visible: flagBasedFeatures.get(FUNDS_TRANSFER) && type === TYPE_FUNDS,
                link: MYPROFILE_BROKER_INTERNAL_TRANSFER_FUND,
                handleClick: () => this.handleMenuTagging(type, 'transferBetweenFunds'),
                text: formatText('brokerMyInvestmentsMoreOptions-trasspassFunds')
            },
            {
                visible: type === TYPE_PLANS && itemsNumber > 0,
                link: BROKER_TRANSFER_PENSION_PLAN_URL,
                handleClick: () => this.handleMenuTagging(type, 'transferBetweenPlans'),
                text: formatText('brokerMyInvestmentsMoreOptions-traspassBetweenMyPlans')
            },
            {
                visible: type === TYPE_PLANS,
                link: BROKER_TRANSFER_PENSION_PLAN_URL,
                handleClick: () => this.handleMenuTagging(type, 'getMyPlans'),
                text: formatText('brokerMyInvestmentsMoreOptions-brokerMyInvestmentsMoreOptions_bringPlansToOpenBank')
            },
            {
                visible: type === TYPE_PLANS,
                handleClick: () => this.handleContributionsSimulatorClick(type, 'contributionsSimulator'),
                text: formatText('brokerMyInvestmentsMoreOptions-PlansContributionsSimulator')
            },
            {
                visible: type === TYPE_PLANS,
                link: `/myprofile/broker/benefitsSimulator`,
                handleClick: () => this.handleMenuTagging(type, 'benefitsSimulator'),
                text: formatText('brokerMyInvestmentsMoreOptions-PlansBenefitsSimulator')
            },
            {
                visible: !__CONTACT_CENTER__ && type === TYPE_STOCKS && flagBasedFeatures.get(OPENTRADER),
                handleClick: () => this.handleOpenTraderClick(type, 'openTrader') ,
                text: formatText('brokerMyInvestmentsMoreOptions-opentrader')
            },
            {
                visible: (type !== TYPE_OTHERS && itemsNumber > 0) || (type === LABEL_ALTERNATIVE_FUNDS && itemsNumber >= 0) || (type === TYPE_CRYPTO_PG && itemsNumber >= 0),
                handleClick: () => this.handleOrdersAndMovementsClick(type, 'movementsAndOrders'),
                text: formatText('brokerMyInvestmentsMoreOptions-ordersAndMovements')
            },
            {
                visible: !__CONTACT_CENTER__ &&  (type === TYPE_WARRANTS || type === TYPE_ETFS) && flagBasedFeatures.get(OPENTRADER),
                handleClick: () => this.handleOpenTraderClick(type, 'opentrader'),
                text: formatText('brokerMyInvestmentsMoreOptions-opentrader')
            },
            {
                visible: type === TYPE_PLANS,
                link: `/myprofile/broker/plansInfo`,
                handleClick: () => this.handleMenuTagging(type, 'rescueInformation'),
                text: formatText('brokerMyInvestmentsMoreOptions-plansInfo')
            },
            {
                visible: type === TYPE_PLANS && itemsNumber > 0,
                link: MYPROFILE_BROKER_PENSION_PLAN_PERIODICAL_CONTRIBUTION_URL,
                handleClick: () => this.handleMenuTagging(type, 'regularContributions'),
                text: formatText('brokerMyInvestmentsMoreOptions-periodicalContributionManagement')
            },
            {
                visible: type === TYPE_OTHERS || type === TYPE_STOCKS,
                link: BROKER_CORPORATE_OPERATIONS_URL,
                handleClick: () => this.handleMenuTagging(type, 'ongoingTransactions'),
                text: formatText('broker-productCorporatesOperationsMoreOptionsOthers')
            },
            {
                visible: ffContributions && type === TYPE_FUNDS,
                link: `/myprofile/broker/contributionManagment`,
                handleClick: () => this.handleMenuTagging(type, 'contributionManagment'),
                text: formatText('brokerMyInvestmentsMoreOptionsWealth-contributionManagment')
            },
            /*{
                visible: type === TYPE_STOCKS || type === TYPE_WARRANTS || type === TYPE_ETFS,
                link: `/myprofile/broker`,
                handleClick: () => this.handleMenuTagging(type, 'seeParticipans'),
                text: formatText('brokerMyInvestmentsMoreOptions-interveniersValuesContract')
            },*/
            /*{
                visible: type === TYPE_FUNDS,
                link: `/myprofile/broker`,
                handleClick: () => this.handleMenuTagging(type, 'seeParticipans'),
                text: formatText('brokerMyInvestmentsMoreOptions-interveniers')
            },*/
        ];

        return items;
    }

    buildActualValueLabel() {
        const actualValue = formatWithoutRound(this.props.total, 2);
        const actualValueCurrency = formatCurrency(this.props.currency);
        const actualValueFormatted = `${actualValue} ${actualValueCurrency}`;

        return <span>{actualValueFormatted}</span>;
    }

    buildCapitalAmountLabel() {
        const { capital, earnings } = this.props;

        if (this.props.type === TYPE_OTHERS) {
            return HYPHEN;
        } else if (capital == null || earnings == null) {
            return <FormattedText value="broker-myInvestmentsNotAvailableInitials" />;
        } else {
            const investment = formatWithoutRound(capital, 2);
            const investmentCurrency = formatCurrency(this.props.currency);
            const investmentFormatted = `${investment} ${investmentCurrency}`;

            return <span>{investmentFormatted}</span>;
        }
    }

    buildEarningsAmountLabel() {
        const { capital, earnings, earningsPercentage } = this.props;

        if (this.props.type === TYPE_OTHERS) {
            return HYPHEN;
        } else if (capital == null || earnings == null) {
            return <FormattedText value="broker-myInvestmentsNotAvailableInitials" />;
        } else {
            const profitability = formatWithoutRound(earnings, 2);
            const profitabilityCurrency = formatCurrency(this.props.currency);
            const percentage = formatWithoutRound(earningsPercentage, 2);

            return this.buildProfitability(profitability, profitabilityCurrency, percentage);
        }
    }

    buildHeader() {
        const {
            itemsNumber,
            excludedItemsLabel,
            hasExcludedItems,
            type
        } = this.props;

        const capitalAmountLabel = this.buildCapitalAmountLabel();

        const earningsAmountLabel = this.buildEarningsAmountLabel();

        const totalAmount = this.buildActualValueLabel();

        let excludedItemsCounter;

        if (hasExcludedItems) {
            excludedItemsCounter = (
                <span className="broker-my-investments-wrap__excluded">
                    {excludedItemsLabel}
                </span>
            );
        }

        const popoverMenuTarget = <OKIconButton size="small" icon="icon-s-op-comp" />;

        const menuItems = this.getPopoverMenuItems();
        const menuVisible = this.checkMenuVisible(menuItems);

        const accordionHeaderRow = classNames(
            'broker-products-wrap__balance row',
            {
                'col-xs-7': menuVisible || type === TYPE_CRYPTO_PG,
                'col-xs-8': !menuVisible && type !== TYPE_CRYPTO_PG,
            }
        );

        let statsBlock;

        if (type == TYPE_OTHERS) {
            statsBlock = (
                <span className="broker-products-wrap__total col-xs-4 col-offset-xs-7">
                    <span className="broker-products-wrap__subtitle">
                        {formatText('broker-myInvestmentsProductsWrapTotalAmountLabel')}
                    </span>
                    <span className="broker-products-wrap__total-value">
                        {totalAmount}
                    </span>
                </span>
            );
        } else {
            statsBlock = (
                <React.Fragment>
                    <span className="broker-products-wrap__capital col-xs-4">
                        <span className="broker-products-wrap__subtitle">
                            {formatText('broker-myInvestmentsProductsWrapInvestedCapitalLabel')}
                        </span>
                        <span className="broker-products-wrap__capital-value">
                            {capitalAmountLabel}
                        </span>
                    </span>
                    <span className="broker-products-wrap__earnings col-xs-4">
                        <span className="broker-products-wrap__subtitle">
                            {formatText('broker-myInvestmentsProductsWrapEarningsLabel')}
                        </span>
                        <span className="broker-products-wrap__earnings-value">
                            {earningsAmountLabel}
                        </span>
                    </span>
                    <span className="broker-products-wrap__total col-xs-3">
                        <span className="broker-products-wrap__subtitle">
                            {formatText('broker-myInvestmentsProductsWrapTotalAmountLabel')}
                        </span>
                        <span className="broker-products-wrap__total-value">
                            {totalAmount}
                        </span>
                    </span>
                </React.Fragment>
            )
        }

        return (
            <div className="broker-my-investments-wrap__header row">
                <div className="broker-products-wrap__title col-xs-4">
                    <span className="broker-products-wrap__type">
                        {this.buildProductTitle()}
                    </span>
                    <span className="broker-my-investments-wrap__items-number">
                        ({itemsNumber}) {excludedItemsCounter}
                    </span>
                </div>
                <div className={this.props.type === TYPE_ALTERNATIVE_FUNDS_PG && this.props.total === 0 ? 'broker-products-wrap__balance row col-xs-7' : accordionHeaderRow}>
                    {statsBlock}
                    {
                        menuVisible &&
                            <div className="broker-products-wrap__dropdown-menu col-xs-1">
                                <PopoverMenu
                                    target={popoverMenuTarget}
                                    items={menuItems}
                                    placement="bottomRight"
                                 />
                            </div>
                    }
                </div>
            </div>
        );
    }

    isAccountOwner (){
        const { immAccounts } = this.props;
        return immAccounts.get('byOrder').filter((accountId) => {
            const immAccount = immAccounts.getIn(['byId', accountId]);
                return immAccount.get('interventionType') === ACCOUNT_INTERVENTION_OWNER;
        })
    }

    getEventAction(type) {
        const eventAction = {
            stocks: 'stocks',
            funds: 'funds',
            FONDOS_ALTERNATIVOS: 'alternativeFunds',
            plans: 'plans',
            etfs: 'etfs',
            warrants: 'warrants',
            crypto: 'crypto',
        };

        return eventAction[type];
    }

    fireTaggingTrace(type, productType) {
        taggingEventHandled(this.props.pageName, 'brokerProductsTableLink', this.getEventAction(type));
        taggingEventHandled(this.props.pageName, 'productsTableAccordionNewTag', this.getEventAction(type), productType);

    }

    buildProductTitle() {
        const { productType, type } = this.props;

        switch (type) {
            case TYPE_STOCKS:
                return (
                    <OKLink
                        extraClass="broker-products-wrap__button-title"
                        to={MYPROFILE_BROKER_STOCKS_URL}
                        onClick={() => this.fireTaggingTrace(type, productType)}
                    >
                        {productType}
                    </OKLink>
                );
            case TYPE_ETFS:
                return (
                    <OKLink
                        extraClass="broker-products-wrap__button-title"
                        to={MYPROFILE_BROKER_ETFS_URL}
                        onClick={() => this.fireTaggingTrace(type)}
                    >
                        {productType}
                    </OKLink>
                );
            case TYPE_WARRANTS:
                return (
                    <OKLink
                        extraClass="broker-products-wrap__button-title"
                        to={MYPROFILE_BROKER_WARRANTS_URL}
                        onClick={() => this.fireTaggingTrace(type)}
                    >
                        {productType}
                    </OKLink>
                );
            case TYPE_FUNDS:
                return (
                    <OKLink
                        extraClass="broker-products-wrap__button-title"
                        to={MYPROFILE_BROKER_FUNDS_URL}
                        onClick={() => this.fireTaggingTrace(type)}
                    >
                        {productType}
                    </OKLink>
                );
            case TYPE_PLANS:
                return (
                    <OKLink
                        extraClass="broker-products-wrap__button-title"
                        to={MYPROFILE_BROKER_PLANS_URL}
                        onClick={() => this.fireTaggingTrace(type)}
                    >
                        <FormattedText value="broker-myInvestmentsProductsPlansLabel" />
                    </OKLink>
                );
            case TYPE_ALTERNATIVE_FUNDS_PG:
                return (
                    <OKLink
                        extraClass="broker-products-wrap__button-title"
                        to={'/myprofile/broker/alternative-funds'}
                        onClick={() => this.fireTaggingTrace(type)}
                    >
                        <FormattedText value="broker-myInvestmentsProductsAlternativeFundsLabel" />
                    </OKLink>
                );
            case TYPE_CRYPTO_PG:
                return (
                    <OKLink
                        extraClass="broker-products-wrap__button-title"
                        to={MYPROFILE_BROKER_CRYPTO_URL}
                        onClick={() => this.fireTaggingTrace(type)}
                    >
                        <FormattedText value="broker-myInvestmentsProductsCryptoLabel" />
                    </OKLink>
                );
            case TYPE_OTHERS:
                return <FormattedText value="broker-myInvestmentsProductsOthersLabel" />;
            default:
                return productType;
        }
    }

    buildProfitability(value, currency, percentage) {
        return (
            <div>
                <span className="broker-products-wrap__earnings-value-currency">
                    <span className="broker-products-wrap__earnings-value">{value}</span>
                    <span className="broker-products-wrap__earnings-currency">{currency}</span>
                    <span className="broker-products-wrap__earnings-separator">|</span>
                </span>
                <span className="broker-products-wrap__earnings-percentage">{percentage}%</span>
            </div>
        )
    }

    handleMenuTagging(type, tag) {
        taggingEventHandled(this.props.pageName, 'optionsMenu', tag, type);
    }

    handleContributionsSimulatorClick(type, tag) {
        this.handleMenuTagging(type, tag);
        window.open(`${getPublicSiteUrl()}/simulador-de-aportaciones`, '_blank');
    }

    handleOpenTraderClick(type, tag) {
        this.handleMenuTagging(type, tag);
        this.props.onOpenTraderClick();
    }

    handleOrdersAndMovementsClick(type, tag) {
        this.handleMenuTagging(type, tag);
        this.props.setOrdersAndMovementsAccessFrom(type);
        this.props.history.push(MYPROFILE_BROKER_ORDERSANDMOVEMENTS_URL);
    }

    handleAcordionClick(type) {
        this.props.setAcordionExpandedValue(type);
    }

    handleAccordionToggle(type) {
        const { productType } = this.props;
        taggingEventHandled(this.props.pageName, 'productsTableAccordion', this.getEventAction(type));
        taggingEventHandled(this.props.pageName, 'productsTableAccordionNewTag', this.getEventAction(type), productType);
    }

    render() {
        const { children, type, immBrokerMyInvestmentWidget } = this.props;
        const header = this.buildHeader();
        const waferIsExpanded = immBrokerMyInvestmentWidget.getIn(['waferIsExpanded', type]);
        const waferStyle = classNames(
            'broker-products-wrap',
            {
                'broker-products-wrap--not-expanded': !waferIsExpanded,
                'broker-products-wrap--expanded': waferIsExpanded
            },
            `broker-products-wrap--${type}`
        );

        return (
            <Accordion
                id={`brokerProduct-${type}`}
                isExpanded={waferIsExpanded}
                onClick={() => this.handleAcordionClick(type)}
                onToggle={() => this.handleAccordionToggle(type)}
                hasLargeContent={false}
                customClassName={waferStyle}
            >
                <AccordionHeader name="AccordionHeader">
                    {header}
                </AccordionHeader>
                <AccordionBody name="AccordionBody">
                    {children}
                </AccordionBody>
            </Accordion>
        );
    }
}

BrokerMyInvestmentsWrappedProductsTable.propTypes = {
    children: PropTypes.any,
    productType: PropTypes.string,
    itemsNumber: PropTypes.number,
    excludedItemsLabel: PropTypes.string,
    hasExcludedItems: PropTypes.bool,
    earnings: PropTypes.number,
    earningsPercentage: PropTypes.number,
    total: PropTypes.number,
    capital: PropTypes.number,
    currency: PropTypes.string,
    type: PropTypes.string,
    isContractSection: PropTypes.bool,
    onOpenTraderClick: PropTypes.func.isRequired,
    setOrdersAndMovementsAccessFrom: PropTypes.func.isRequired,
    setAcordionExpandedValue: PropTypes.func,
    immAccounts: PropTypes.object,
    immBrokerMyInvestmentWidget: PropTypes.object,
    flagBasedFeatures: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    pageName: PropTypes.string
};

module.exports.constructor = BrokerMyInvestmentsWrappedProductsTable;
module.exports.BrokerMyInvestmentsWrappedProductsTable = connect(
    state => ({
        immBrokerMyInvestmentWidget: state.brokerMyInvestmentWidget,
    }),
    {
        setAcordionExpandedValue: BrokerMyInvestmentWidgetActions.setAcordionExpandedValue
    }
)(withFeatureToggling(withRouter(BrokerMyInvestmentsWrappedProductsTable)));
